import client from '@/services/';

const state = () => ({
    all: [],
    one: {},
    selectedDemande: null,
});

const getters = {
    all: state => state.all,
    one: state => state.one
};

const mutations = {
    SET_ALL: (state, obj) => {
        state.all = obj;
    },
    SET_ONE: (state, obj) => {
        state.one = obj;
    },
    SET_SELECTED_DEMANDE(state, demande) {
        state.selectedDemande = demande;
    },
    CLEAR_SELECTED_DEMANDE(state) {
        state.selectedDemande = null;
    },
};

const actions = {
    async getAll(cxt) {
        let data = await client.get('demandes/all');
        cxt.commit("SET_ALL", data);
        return data;
    },
    async getAllP({ commit }, params = {}) {
        const { page = 0, size = 10, sort = '', chiffreAffaire, montantCotisation, montantFraisDeDossier, cotisationFixeMaintien, cotisationVariableMaintien, state, type, codeRef, sexe, email, sousLibelle, sousCode, imported, treatmentDateAfter, treatmentDateBefore, after, before, dateValidationPaiementAfter, dateValidationPaiementBefore, nom, prenoms, progress, paiementValide, traite } = params;
        const queryParams = new URLSearchParams({
            page,
            size,
            sort,
            ...(chiffreAffaire && { chiffreAffaire }),
            ...(montantCotisation && { montantCotisation }),
            ...(montantFraisDeDossier && { montantFraisDeDossier }),
            ...(cotisationFixeMaintien && { cotisationFixeMaintien }),
            ...(cotisationVariableMaintien && { cotisationVariableMaintien }),
            ...(state && { state }),
            ...(type && { type }),
            ...(codeRef && { codeRef }),
            ...(sexe && { sexe }),
            ...(email && { email }),
            ...(sousLibelle && { sousLibelle }),
            ...(sousCode && { sousCode }),
            ...(imported && { imported }),
            ...(treatmentDateAfter && { treatmentDateAfter }),
            ...(treatmentDateBefore && { treatmentDateBefore }),
            ...(after && { after }),
            ...(before && { before }),
            ...(dateValidationPaiementAfter && { dateValidationPaiementAfter }),
            ...(dateValidationPaiementBefore && { dateValidationPaiementBefore }),
            ...(nom && { nom }),
            ...(prenoms && { prenoms }),
            ...(progress && { progress }),
            ...(paiementValide && { paiementValide }),
            ...(traite && { traite }),
        }).toString();
        let { data } = await client.get(`demandes/all/custom?${queryParams}`);
        commit("SET_ALL", data)
        //cxt.commit("SET_ALL", data);
        return data;
    },
    async exportExcel({ commit }, params = {}) {
        try {
            const { page = 0, size = 10, sort = '', chiffreAffaire, montantCotisation, montantFraisDeDossier, cotisationFixeMaintien, cotisationVariableMaintien, state, type, codeRef, sexe, email, sousLibelle, sousCode, imported, treatmentDateAfter, treatmentDateBefore, after, before, dateValidationPaiementAfter, dateValidationPaiementBefore, nom, prenoms, progress, paiementValide, traite, prevalidation } = params;
            
            // Construire les paramètres de requête en excluant les valeurs vides
            const queryParams = new URLSearchParams();
            
            // Ajouter seulement les paramètres qui ont des valeurs
            if (page !== undefined) queryParams.append('page', page);
            if (size !== undefined) queryParams.append('size', size);
            if (sort) queryParams.append('sort', sort);
            if (chiffreAffaire) queryParams.append('chiffreAffaire', chiffreAffaire);
            if (montantCotisation) queryParams.append('montantCotisation', montantCotisation);
            if (montantFraisDeDossier) queryParams.append('montantFraisDeDossier', montantFraisDeDossier);
            if (cotisationFixeMaintien) queryParams.append('cotisationFixeMaintien', cotisationFixeMaintien);
            if (cotisationVariableMaintien) queryParams.append('cotisationVariableMaintien', cotisationVariableMaintien);
            if (state) queryParams.append('state', state);
            if (type) queryParams.append('type', type);
            if (codeRef) queryParams.append('codeRef', codeRef);
            if (sexe) queryParams.append('sexe', sexe);
            if (email) queryParams.append('email', email);
            if (sousLibelle) queryParams.append('sousLibelle', sousLibelle);
            if (sousCode) queryParams.append('sousCode', sousCode);
            if (imported) queryParams.append('imported', imported);
            if (treatmentDateAfter) queryParams.append('treatmentDateAfter', treatmentDateAfter);
            if (treatmentDateBefore) queryParams.append('treatmentDateBefore', treatmentDateBefore);
            if (after) queryParams.append('after', after);
            if (before) queryParams.append('before', before);
            if (dateValidationPaiementAfter) queryParams.append('dateValidationPaiementAfter', dateValidationPaiementAfter);
            if (dateValidationPaiementBefore) queryParams.append('dateValidationPaiementBefore', dateValidationPaiementBefore);
            if (nom) queryParams.append('nom', nom);
            if (prenoms) queryParams.append('prenoms', prenoms);
            if (progress) queryParams.append('progress', progress);
            if (paiementValide) queryParams.append('paiementValide', paiementValide);
            if (traite) queryParams.append('traite', traite);
            if (prevalidation) queryParams.append('prevalidation', prevalidation);
                        
            const response = await client.get(`/demandes/export/excel?${queryParams.toString()}`, {
                responseType: 'blob'
            });
            return response.data;
        } catch (error) {
            console.error('Erreur lors de l\'export Excel:', error);
            throw error;
        }
    },
    async getAllPMaintient({ commit }, params = {}) {
        const { page = 0, size = 10, sort = '', chiffreAffaire, montantCotisation, montantFraisDeDossier, cotisationFixeMaintien, cotisationVariableMaintien, state, type, paiementValide, codeRef, sexe, email, sousLibelle, sousCode, imported, treatmentDateAfter, treatmentDateBefore, after, before, dateValidationPaiementAfter, dateValidationPaiementBefore, nom, prenoms, progress, traite, prevalidation } = params;
        const queryParams = new URLSearchParams({
            page,
            size,
            sort,
            ...(chiffreAffaire && { chiffreAffaire }),
            ...(montantCotisation && { montantCotisation }),
            ...(montantFraisDeDossier && { montantFraisDeDossier }),
            ...(cotisationFixeMaintien && { cotisationFixeMaintien }),
            ...(cotisationVariableMaintien && { cotisationVariableMaintien }),
            ...(state && { state }),
            ...(type && { type }),
            ...(paiementValide && { paiementValide }),
            ...(codeRef && { codeRef }),
            ...(sexe && { sexe }),
            ...(email && { email }),
            ...(sousLibelle && { sousLibelle }),
            ...(sousCode && { sousCode }),
            ...(imported && { imported }),
            ...(treatmentDateAfter && { treatmentDateAfter }),
            ...(treatmentDateBefore && { treatmentDateBefore }),
            ...(after && { after }),
            ...(before && { before }),
            ...(dateValidationPaiementAfter && { dateValidationPaiementAfter }),
            ...(dateValidationPaiementBefore && { dateValidationPaiementBefore }),
            ...(nom && { nom }),
            ...(prenoms && { prenoms }),
            ...(progress && { progress }),
            ...(traite && { traite }),
            ...(prevalidation && { prevalidation }),
        }).toString();
        let { data } = await client.get(`demandes/maintien?${queryParams}`);
        commit("SET_ALL", data)
        //cxt.commit("SET_ALL", data);
        return data;
    },
    async getOne(cxt, id) {
        let data = await client.get('demandes/one/' + id);
        cxt.commit("SET_ONE", data);
        return data;
    },
    async create(cxt, payload) {
        let { data } = payload.id ? await client.put('demandes/edit/' + payload.id, payload) : await client.post('demandes/add', payload);
        cxt.commit("SET_ONE", data);
        if (payload.id) {
            payload.id = null;
        }

        return data;
    },
    async initDemande(cxt, payload){
        let { data } = await client.post('demandes/add-renouvellement', payload);
        return data;
    },
    async update(cxt, payload) {
        let { data } = await client.put('demandes/edit/' + payload.id, payload);
        cxt.commit("SET_ONE", data);
        return data;
    },
    async updateIdentite(cxt, payload) {
        let { data } = await client.put('demandes/identite/' + payload.id, payload);
        cxt.commit("SET_ONE", data);
        return data;
    },
    async suiviDemande(cxt, payload) {
        let data = await client.post('demandes/suivi', payload);
        cxt.commit("SET_ONE", data);
        cxt.commit("SET_SELECTED_DEMANDE", data);
        return data;
    },
    async del(cxt, id) {
        let { data } = await client.delete('demandes/delete/' + id);
        cxt.commit("SET_ONE", data);
        return data;
    },
    async receptionDemande(cxt, id) {
        let { data } = await client.get('demandes/activate/' + id);
        cxt.commit("SET_ONE", data);
        return data;
    },
    async resendMail(cxt, id) {
        let { data } = await client.get('/demandes/send/notification/import/' + id);
        return data;
    },
    async traitementDemande(cxt, payload) {
        let data = await client.post('demandes/treat', payload);
        cxt.commit("SET_ONE", data);
        return data;
    },
    async recevabilite(cxt, payload) {
        return client.post('demandes/recevabilite', payload);
    },
    async toursRecevabilite(cxt, id) {
        return client.get('demandes/' + id + '/tours-recevabilite');
    },
    async renvoyerMailCorrection(cxt, id) {
        return client.post('demandes/' + id + '/renvoyer-mail-correction');
    },
    async correctionInformation(cxt, payload) {
        let { data } = await client.post('demandes/add/corrigee', payload);
        cxt.commit("SET_ONE", data);
        if (payload.id) {
            payload.id = null;
        }

        return data;
    },
    async getAllDemandeConnectee({ commit }, params = {}) {
        const { page = 0, size = 10, sort = '', type, after, before } = params;
        const queryParams = new URLSearchParams({
            page,
            size,
            sort,
            ...(type && { type }),
            ...(after && { after }),
            ...(before && { before }),
        }).toString();
        let { data } = await client.get(`/demandes/connected?${queryParams}`);
        return data;
    },
    async getInProgressConnected() {
        try {
            let { data, status } = await client.get('/demandes/connected/in-progress');
            if (status === 204 || !data) return [];
            return data;
        } catch (e) {
            if (e?.response?.status === 204) return [];
            throw e;
        }
    },
    async getConnectedById(cxt, id) {
        let { data } = await client.get(`/demandes/connected/${id}`);
        return data;
    },
    async initPaiement(cxt, { demandeId, payload }) {
        let { data } = await client.post(`demandes/${demandeId}/paiements/init`, payload);
        return data;
    },
    async confirmPaiement(cxt, { demandeId, payload }) {
        let { data } = await client.post(`demandes/${demandeId}/paiements/confirm`, payload);
        return data;
    },
    async reconcilePaiements(cxt, demandeId) {
        let { data } = await client.post(`demandes/${demandeId}/paiements/reconcile`);
        return data;
    },
    async statistiqueGlobale() {
        let data = await client.get('/stat/all');
        //cxt.commit("SET_ALL", data);
        return data;
    },
    async statistiquePerso () {
        let data = await client.get('/stat/user/dashboard');
        //cxt.commit("SET_ALL", data);
        return data;
    },
    async validationComite(cxt, payload) {
        let { data } = await client.post('demandes/validate', payload);
        return data;
    },
    async savePrevalidation(cxt, payload) {
        // payload: { demandeId, paiementConforme, formation40hConforme, documents: [...] }
        let { data } = await client.post('demandes/prevalidation', payload);
        return data;
    },
    async exportPrevalidationExcel({ commit }, params = {}) {
        try {
            // On réutilise les mêmes filtres que pour getAllPMaintient
            const { page = 0, size = 10, sort = '', chiffreAffaire, montantCotisation, montantFraisDeDossier, cotisationFixeMaintien, cotisationVariableMaintien, state, type, codeRef, sexe, email, sousLibelle, sousCode, imported, treatmentDateAfter, treatmentDateBefore, after, before, dateValidationPaiementAfter, dateValidationPaiementBefore, nom, prenoms, progress, paiementValide, traite, prevalidation } = params;
            const queryParams = new URLSearchParams({
                page,
                size,
                sort,
                ...(chiffreAffaire && { chiffreAffaire }),
                ...(montantCotisation && { montantCotisation }),
                ...(montantFraisDeDossier && { montantFraisDeDossier }),
                ...(cotisationFixeMaintien && { cotisationFixeMaintien }),
                ...(cotisationVariableMaintien && { cotisationVariableMaintien }),
                ...(state && { state }),
                ...(type && { type }),
                ...(codeRef && { codeRef }),
                ...(sexe && { sexe }),
                ...(email && { email }),
                ...(sousLibelle && { sousLibelle }),
                ...(sousCode && { sousCode }),
                ...(imported && { imported }),
                ...(treatmentDateAfter && { treatmentDateAfter }),
                ...(treatmentDateBefore && { treatmentDateBefore }),
                ...(after && { after }),
                ...(before && { before }),
                ...(dateValidationPaiementAfter && { dateValidationPaiementAfter }),
                ...(dateValidationPaiementBefore && { dateValidationPaiementBefore }),
                ...(nom && { nom }),
                ...(prenoms && { prenoms }),
                ...(progress && { progress }),
                ...(paiementValide && { paiementValide }),
                ...(traite && { traite }),
                ...(prevalidation && { prevalidation }),
            }).toString();

            const response = await client.get(`/demandes/prevalidation/export?${queryParams}`, {
                responseType: 'blob'
            });
            return response.data;
        } catch (error) {
            console.error('Erreur lors de l\'export du rapport de prévalidation:', error);
            throw error;
        }
    },
    async resendMailCompte(cxt, demandeId) {
        let { data } = await client.post('demandes/resend/notification/' + demandeId);
        return data;
    },
    async resendDocumentInscription(cxt, demandeId) {
        let { data } = await client.post('demandes/renvoyer-document-inscription/' + demandeId);
        return data;
    },
    async resendCertificatRenouvellement(cxt, demandeId) {
        let { data } = await client.post('demandes/renvoyer-certificat-renouvellement/' + demandeId);
        return data;
    },
    async statistiqueByType (cxt, type) {
        let data = await client.get('/demandes/stats/' + type);
        return data;
    },
    async addPaiement(cxt, { demandeId, payload }) {
        let { data } = await client.post(`demandes/${demandeId}/paiements`, payload);
        return data;
    },
    async getPaiements(cxt, demandeId) {
        let { data } = await client.get(`demandes/${demandeId}/paiements`);
        return data;
    },
    async attachFichier(cxt, { demandeId, fichierId }) {
        let { data } = await client.post(`demandes/${demandeId}/fichiers/${fichierId}`);
        return data;
    },
    async validatePaiementDemande(cxt, { idPaiement, id, dateValidation }) {
        let { data } = await client.put(`demandes/paiement/${idPaiement}/validation-paiement`, { id, dateValidation });
        return data;
    },
    // Nouvelle méthode pour ajouter/modifier un commentaire
    async ajouterCommentaire(cxt, payload) {
        const { demandeId, commentaire, typeCommentaire } = payload;
        let { data } = await client.post('demandes/commentaire', {
            demandeId,
            commentaire,
            typeCommentaire
        });
        return data;
    },
    // Nouvelle méthode pour récupérer tous les commentaires d'une demande
    async getCommentaires(cxt, demandeId) {
        let { data } = await client.get(`demandes/${demandeId}/commentaires`);
        return data;
    },
    // Nouvelle méthode pour récupérer un commentaire spécifique
    async getCommentaireByType(cxt, { demandeId, type }) {
        let { data } = await client.get(`demandes/${demandeId}/commentaires/${type}`);
        return data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
